import { useEffect, useState } from "react";
import type { ChatSocket } from "app/Booking/Messages/types";

interface PresenceUpdatePayload {
    user_id: string;
    is_online: boolean;
}

export const useInterlocutorPresence = (socket: ChatSocket, interlocutorUserId: string | undefined): boolean => {
    const [isOnline, setIsOnline] = useState(false);

    useEffect(() => {
        if (!interlocutorUserId) {
            setIsOnline(false);
            return;
        }

        socket.emit("join_room", interlocutorUserId);

        const handlePresenceUpdate = (payload: PresenceUpdatePayload) => {
            if (payload.user_id === interlocutorUserId) {
                setIsOnline(payload.is_online);
            }
        };

        socket.on("presence_update", handlePresenceUpdate);

        return () => {
            socket.off("presence_update", handlePresenceUpdate);
            setIsOnline(false);
        };
    }, [socket, interlocutorUserId]);

    return isOnline;
};
